import { PaginationQuery, PaginationQueryDefaultValues } from "../pagination/pagination-query";

export interface OrgList
{
    id: string,
    organizationName:string,
    province:string,
    status:string

}

export function OrgListDefaultValues():OrgList
{
   return {
    id: '',
    organizationName:"",
    province:"",
    status:"",
    
   }
}

export type OrgQuery=PaginationQuery & 
{
    OrgKeyword:string,
    ProvinceId:number,
    Status:string
}

export function OrgQueryDefaultValues():OrgQuery
{
    return{
        OrgKeyword:'',
        ProvinceId:0,
        Status:'',
        ...PaginationQueryDefaultValues()
    }
}